import { Component, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-skeleton',
  template: `<div
    class="skeleton"
    [ngStyle]="{
      width: circle ? height : width,
      height: height,
      borderRadius: circle ? '50%' : '1.563rem',
    }"
  ></div>`,
  styleUrls: ['./skeleton.component.css'],
  imports: [NgStyle],
})
export class SkeletonComponent {
  @Input() width = '100%';
  @Input() height = '1rem';
  @Input() circle = false;
}
